import { Component, Input, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogNewsComponent } from "../dialog-news/dialog-news.component";
import { environment } from "../../../environments/environment";
import { INews, INewsDetail } from "app/interfaces/i-news";

@Component({
  standalone: false,
    selector: "app-swiper",
    templateUrl: "./swiper.component.html",
    styleUrls: ["./swiper.component.scss"],
})
export class SwiperComponent implements OnInit, OnDestroy {
    @Input() slides: INewsDetail[];
    @Input() ticketID: number;

    public slideStyles: { [key: string]: any } = {};
    public base_url = environment.api_url;
    public colors = [
        "rgb(0, 140, 255)",
        "rgb(10, 184, 111)",
        "rgb(211, 122, 7)",
        "rgb(118, 163, 12)",
        "rgb(180, 10, 47)",
        "rgb(35, 99, 19)",
        "rgb(0, 68, 255)",
        "rgb(218, 12, 218)",
        "rgb(54, 94, 77)",
    ];

    constructor(public dialog: MatDialog, private renderer: Renderer2) {}

    ngOnInit(): void {
        this.applySlideStyles(this.slides);
    }

    private applySlideStyles(_slides: INewsDetail[]) {
        _slides.forEach((slide, index) => {
            const color = this.colors[index % this.colors.length];
            const styleElement = this.renderer.createElement("style");
            styleElement.textContent = `swiper-slide:nth-child(${
                index + 1
            }) { background-color: ${color}; }`;
            this.renderer.appendChild(document.head, styleElement);
        });
    }

    openPopup(slide: INewsDetail) {
        this.dialog.open(DialogNewsComponent, {
            data: { slide, ticketID: this.ticketID },
        });
    }

    ngOnDestroy(): void {}
}
